import { render, staticRenderFns } from "./RiepilogoEventiComponent.vue?vue&type=template&id=ea3a0df6"
import script from "./RiepilogoEventiComponent.vue?vue&type=script&lang=js"
export * from "./RiepilogoEventiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports